import * as React from "react";
import { LoadingSkeletonType } from "./Contents";
import { LoadingSkeleton } from "./LoadingSkeleton";

export interface ILoadingSkeletonWrapperProps {
    isLoading: boolean;
    skeletonType: LoadingSkeletonType;
    skeletonCssWrapper?: string;
    children: React.ReactNode;
}

export function LoadingSkeletonWrapper(props: ILoadingSkeletonWrapperProps) {
    if (props.isLoading) {
        return (
            <div className={props.skeletonCssWrapper}>
                <LoadingSkeleton type={props.skeletonType} />
            </div>
        );
    }
    return <>{props.children}</>;
}
